import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiContact\GetWikiContactByIdController::__invoke
* @see app/Http/Controllers/WikiContact/GetWikiContactByIdController.php
* @route '/api/wiki-contact/{contact}'
*/
const GetWikiContactByIdController = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiContactByIdController.url(args, options),
    method: 'get',
})

GetWikiContactByIdController.definition = {
    methods: ["get","head"],
    url: '/api/wiki-contact/{contact}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiContact\GetWikiContactByIdController::__invoke
* @see app/Http/Controllers/WikiContact/GetWikiContactByIdController.php
* @route '/api/wiki-contact/{contact}'
*/
GetWikiContactByIdController.url = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { contact: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { contact: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            contact: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contact: typeof args.contact === 'object'
        ? args.contact.id
        : args.contact,
    }

    return GetWikiContactByIdController.definition.url
            .replace('{contact}', parsedArgs.contact.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiContact\GetWikiContactByIdController::__invoke
* @see app/Http/Controllers/WikiContact/GetWikiContactByIdController.php
* @route '/api/wiki-contact/{contact}'
*/
GetWikiContactByIdController.get = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiContactByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiContact\GetWikiContactByIdController::__invoke
* @see app/Http/Controllers/WikiContact/GetWikiContactByIdController.php
* @route '/api/wiki-contact/{contact}'
*/
GetWikiContactByIdController.head = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiContactByIdController.url(args, options),
    method: 'head',
})

export default GetWikiContactByIdController